import { isCustomizedType, reduce } from "et3-type-guards";

import { Ti18nKeys } from "../../constants/i18n";
import i18nServerResponse from "../../constants/i18n-server-response";
import { post } from "../axios-post";
import { DEFAULT_TIME } from "../../constants/input-entries-constants";
import { TMediaType } from "../../Types";
import getKhattabatStore from "../../stores/khattabat-stores";
import getKhattabat102MessagingStore from "../../stores/khattabat-stores/messaging-stores/102-messaging-store";

export const apiCallSendOneOTwoMedia = async ({
  oneOTwoConversationId,
  type,
  attachment,
  duration
}: {
  oneOTwoConversationId: string;
  type: TMediaType;
  attachment: string;
  duration: number;
}): Promise<{
  data: {
    messageCurrentTime: string;
    mideaMessage: string;
  };
  status: string;
  code: Ti18nKeys;
}> => {
  const {
    clientReceiverID,
    clientReceiverUUID,
    matchReceiverID,
    matchReceiverUUID
  } = getKhattabat102MessagingStore(oneOTwoConversationId);
  const alkhattabaUUID = getKhattabatStore().alkhattabaUUID.get();

  const { status, data, et3Error } = await post<{
    messageCurrentTime: string;
    mideaMessage: string;
  }>(`khattabat/sendOneOTwoMidea`, {
    alkhattabaUUID,
    clientUserID: clientReceiverID.get(),
    clientUUID: clientReceiverUUID.get(),
    matchID: matchReceiverID.get(),
    matchUUID: matchReceiverUUID.get(),
    type,
    attachment,
    duration
  });
  if (
    status === "OK" &&
    !isCustomizedType<{
      errorCode: string;
      et3Message: string;
    }>(
      {
        errorCode: "ERROR",
        et3Message: "ERROR"
      },
      data
    )
  ) {
    return {
      data,
      status: "OK",
      code: "SUCCESS"
    };
  } else if (status === "ERROR") {
    const errorNumber = reduce(() => et3Error.errorNumber, 0);
    return {
      data: {
        messageCurrentTime: DEFAULT_TIME,
        mideaMessage: ""
      },
      status: "ERROR",
      code: i18nServerResponse.get(errorNumber)
    };
  } else {
    return {
      data: {
        messageCurrentTime: DEFAULT_TIME,
        mideaMessage: ""
      },
      status: "ERROR",
      code: "ERROR"
    };
  }
};
